import React, { useEffect, useState, useRef } from "react";
import { fetchPostCriterias, fetchSubjectsByExamAndPost, getAdvertisementlistByYear, getAllTransactionalDataTypes, getExamName, getExamTypeLookup, getFileUploadStatus, getPostCriteriaByExamId, getResultFlowAdvertisementList, getResultFlowInfo, getResultFlowYearList, getYearList, saveResultFlow } from "../actions/commonActions";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { getExamslistByAdvertisementId, getSubjectlistByExamId } from "../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import label from "../../common/labels/common_en.json";
import { SET_FILE_UPLOAD_STATUS } from "../constants/ActionTypes";
import { getAdminCategory } from "../../interviewProcess/actions/interviewProcessActions";

const ResultFLow = () => {

    const dispatch = useDispatch();
    const [selectedType, setSelectedType] = useState("");
    const [allTypes, setAllTypes] = useState([]);
    const [typeId, setTypeId] = useState("");
    const [isAnswerKeyUpload, setIsAnswerKeyUpload] = useState(false)
    const [saveButtonFlag, setSaveButtonFlag] = useState(false);
    const [reloadItem, setReloadItem] = useState(true);
    const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
    // const [selectedExam, setSelectedExam] = useState("");
    const [selectedSubject, setSelectedSubject] = useState("");

    const [subjectTableData, setSubjectTableData] = useState([]);
    const [examType, setExamType] = useState("");

    const [postSelection, setPostSelection] = useState("NO");
    const [interviewMarks, setInterviewMarks] = useState({
        totalMarks: "",
        qualifyingMarks: ""
    });
    const [stages, setStages] = useState({
        interview: "NO",
        physicalTest: "NO",
        medicalTest: "NO",
        skillTest: "NO",
    });
    const [physicalMarks, setPhysicalMarks] = useState({
        totalMarks: "",
        qualifyingMarks: "",
        height: "",
        chest: "",
        running: "",
    });
    const [selectedPostSubject, setSelectedPostSubject] = useState("");
    const [skillMarks, setSkillMarks] = useState({
        totalMarks: "",
        qualifyingMarks: ""
    });
    const [isPostSelectionOptional, setIsPostSelectionOptional] = useState("NO");
    // const [selectedQuestionSet, setSelectedQuestionSet] = useState("");
    const QUESTION_SETS = ["A", "B", "C", "D"];
    const [questionSetRows, setQuestionSetRows] = useState(
        QUESTION_SETS.map((set) => ({
            questionSet: set,
            totalQuestions: "",
            totalMarks: "",
            qualifyingMarks: ""
        }))
    );
    const [subjects, setSubjects] = useState([]);

    const [currentSubject, setCurrentSubject] = useState({
        subjectCode: "",
        examType: "",
        examSubjectConfig: []
    });
    const [totalQuestions, setTotalQuestions] = useState("");
    const [totalMarks, setTotalMarks] = useState("");
    const [qualifyingMarks, setQualifyingMarks] = useState("");
    const [defaultPostCriteriaId, setDefaultPostCriteriaId] = useState(null);
    const [cutoffMarks, setCutoffMarks] = useState({
        finalTotalMarks: "",
        finalCutOff: ""
    });
    // const [selectedPosts, setSelectedPosts] = useState([]);
    const [selectedPosts, setSelectedPosts] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [examChecked, setExamChecked] = useState(false);
    const [selectedExam, setSelectedExam] = useState("");
    const [showExamModal, setShowExamModal] = useState(false);
    const [postMarks, setPostMarks] = useState({
        totalMarks: "",
        qualifyingMarks: ""
    });
    const [activeTest, setActiveTest] = useState(null);
    const [showSummaryTable, setShowSummaryTable] = useState(false);
    const [summaryData, setSummaryData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [medicalMarks, setMedicalMarks] = useState({
        qualifyingStatus: "PASS",
    });
    const [subjectCode, setSubjectCode] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [editGroupIndex, setEditGroupIndex] = useState(null);
    const [editIndex, setEditIndex] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [categoryMark, setCategoryMark] = useState("");
    const [categoryList, setCategoryList] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState("");
    const [editCategoryIndex, setEditCategoryIndex] = useState(null);
    const [editingGroupId, setEditingGroupId] = useState(null);
    const [setCount, setSetCount] = useState("");
    const [selectedAdvertisementIdExam, setSelectedAdvertisementIdExam] = useState("");
    

    let { yearList, allYearList, transactionalDataTypes, postCriteriaList, subjectListPost, resultFlowInfo, lookupOptionsExamType, resultFlowYearList,
        resultFlowAdvertisementList, examName } = useSelector((state) => state.common, shallowEqual);
    let { examList, subjectList } = useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);
    const { adminCategoriesList } = useSelector((state) => state.interviewProcessReducer, shallowEqual);

    const showResultTable =
        resultFlowInfo &&
        Array.isArray(resultFlowInfo.postCriteriaConfigsdTO) &&
        resultFlowInfo.postCriteriaConfigsdTO.length > 0;

    useEffect(() => {
        setAllTypes(transactionalDataTypes);
    }, [transactionalDataTypes]);
    useEffect(() => { }, [reloadItem]);
    useEffect(() => {
        dispatch(getAdminCategory());
    }, [dispatch]);


    useEffect(() => {
        // window.scrollTo(0, 0);
        dispatch(getAllTransactionalDataTypes());
        dispatch({
            payload: {},
            type: SET_FILE_UPLOAD_STATUS,
        });
        // dispatch(getYearList());
        dispatch(getResultFlowYearList());
    }, []);

    const onTypeChange = (value) => {
        setSelectedType(value);

        const selectedObj = allTypes.find(item => item.type === value);
        if (!selectedObj) return;
        setTypeId(selectedObj.id);
        setIsAnswerKeyUpload(!!selectedObj.flgUploadCsv);
        dispatch(getFileUploadStatus(selectedObj.id));
    };

    useEffect(() => {
        if (selectedAdvertisementIdExam) {
            dispatch(getExamName(selectedAdvertisementIdExam));
        }
    }, [selectedAdvertisementIdExam]);

    // const onSelectYear = (ele) => {
    //     let selectedValue = ele;
    //     selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
    //     if (allYearList) {
    //         // allYearList.length = 0
    //     }
    //     if (examList) {
    //         // examList.length = 0;
    //     }
    //     if (subjectList) {
    //         // subjectList.length = 0
    //     }
    //     // reset();
    //     setSaveButtonFlag(true);
    //     setReloadItem(!reloadItem);
    // };

    const onSelectYear = (ele) => {
        let selectedValue = ele;

        setSelectedAdvertNo("");
        setSelectedExam("");
        setSelectedSubject("");

        if (selectedValue) {
            dispatch(getResultFlowAdvertisementList(selectedValue));
        }

        setSaveButtonFlag(true);
        setReloadItem(!reloadItem);
    };

    const onAdvertisementChange = (ele) => {
        let selectedValue = ele;
        setSelectedAdvertNo(selectedValue);
        // examList.length = 0;
        // subjectList.length = 0;
        setSelectedAdvertisementIdExam(ele); 
        setSelectedExam("");
        setSelectedSubject("");
        setSaveButtonFlag(true);
        selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
        setReloadItem(!reloadItem);
    };

    const onExamChange = (ele) => {
        let selectedValue = ele;
        // subjectList.length = 0;
        setSelectedExam(selectedValue);
        dispatch(getExamName(selectedValue));
        setSelectedSubject("");
        setExamType("");
        dispatch(getExamName(selectedAdvertNo));
        setSaveButtonFlag(true);
        selectedValue && dispatch(getSubjectlistByExamId(selectedValue));
        setReloadItem(!reloadItem);
        setCutoffMarks({
            finalTotalMarks: "",
            finalCutOff: ""
        });
    };

    const handleQuestionSetChange = (index, field, value) => {
        const updated = [...questionSetRows];
        updated[index][field] = value;
        setQuestionSetRows(updated);
    };

    const handleQualifyingMarksChange = (index, value) => {
        const updatedData = [...subjectTableData];
        updatedData[index].qualifyingMarks = value;
        setSubjectTableData(updatedData);
    };

    const getFinalSubjectId = () => {
        if (postSelection === "YES") {
            return selectedPostSubject;
        }
        return selectedSubject;
    };

    const handleSave = async () => {
        // ===== POST VALIDATION =====
        if (postSelection === "YES" && (!selectedPosts || selectedPosts.length === 0)) {
            alert("Please select at least one Post");
            return;
        }

        // ===== AT LEAST ONE TEST =====
        const isAnyTestSelected =
            examChecked ||
            stages.interview === "YES" ||
            stages.physicalTest === "YES" ||
            stages.medicalTest === "YES" ||
            stages.skillTest === "YES";

        if (!isAnyTestSelected) {
            alert("Please select at least one Test Criteria");
            return;
        }

        // ===== SUBJECT ADD VALIDATION =====
        if (examChecked) {

            const isCurrentSubjectFilled =
                currentSubject?.subjectCode ||
                currentSubject?.examType ||
                (currentSubject?.examSubjectConfig &&
                    currentSubject.examSubjectConfig.some(
                        row => row.totalQuestions || row.totalMarks || row.qualifyingMarks
                    ));

            if (isCurrentSubjectFilled) {
                alert("Please click Add button to add subject before saving");
                return;
            }

            if (!subjects || subjects.length === 0) {
                alert("Please add at least one Subject");
                return;
            }
        }

        // ===== OBJECTIVE VALIDATION =====
        if (
            examChecked &&
            examType === "OBJECTIVE" &&
            (!questionSetRows || questionSetRows.length === 0)
        ) {
            alert("Please add at least one Question Set");
            return;
        }

        // ===== MEDICAL VALIDATION =====
        if (stages.medicalTest === "YES" && !medicalMarks.qualifyingStatus) {
            alert("Please select Medical qualifying status");
            return;
        }

        try {
            // const subjectListPayload = examChecked
            //     ? subjects.map(sub => ({
            //         subjectCode: sub.subjectCode,
            //         examType: sub.examType,
            //         examRequired: true,
            //         examSubjectConfig: sub.examSubjectConfig
            //     }))
            //     : [];
            const subjectListPayload = subjects.map(sub => ({
                subjectId: sub.subjectId,
                subjectCode: sub.subjectCode,
                examType: sub.examType,
                examRequired: true,

                sets: {
                    count:
                        sub.examType === "OBJECTIVE"
                            ? sub.examSubjectConfig.length
                            : 0,

                    setNames:
                        sub.examType === "OBJECTIVE"
                            ? sub.examSubjectConfig.map(x => x.questionSet)
                            : []
                },

                examSubjectConfig: sub.examSubjectConfig
            }));

            //  POST LEVEL CONFIG (THIS IS KEY)
            const postCriteriaConfig = {
                ...(editMode && editingGroupId && { id: editingGroupId }),
                postCriteriaConfigs: cleanPostCriteriaConfigs,

                postMarks: {
                    totalMarks: Number(postMarks.totalMarks),
                    qualifyingMarks: Number(postMarks.qualifyingMarks),
                },

                examRequired: examChecked,
                interviewRequired: stages.interview === "YES",
                physicalTestRequired: stages.physicalTest === "YES",
                medicalTestRequired: stages.medicalTest === "YES",
                skillTestRequired: stages.skillTest === "YES",

                // subjects: examChecked ? [subjectObj] : [],
                subjects: subjectListPayload,

                categoryDtoList: categoryList.map(cat => ({
                    category: cat.categoryName,   // confirm backend expects name or id
                    totalNumber: Number(cat.mark)
                })),
                ...(stages.interview === "YES" && {
                    interviewConfig: {
                        totalMarks: Number(interviewMarks.totalMarks),
                        qualifyingMarks: Number(interviewMarks.qualifyingMarks),
                    },
                }),
                ...(stages.physicalTest === "YES" && {
                    physicalTestConfig: {
                        totalMarks: Number(physicalMarks.totalMarks),
                        qualifyingMarks: Number(physicalMarks.qualifyingMarks),
                        height: Number(physicalMarks.height),
                        chest: Number(physicalMarks.chest),
                        running: physicalMarks.running,
                    },
                }),

                ...(stages.medicalTest === "YES" && {
                    medicalTestConfig: {
                        medicalTestQualifyingStatus: medicalMarks.qualifyingStatus,
                    },
                }),

                ...(stages.skillTest === "YES" && {
                    skillTestConfig: {
                        totalMarks: Number(skillMarks.totalMarks),
                        qualifyingMarks: Number(skillMarks.qualifyingMarks),
                    },
                }),
            };

            let updatedGroups = Array.isArray(resultFlowInfo?.postCriteriaConfigsdTO)
                ? [...resultFlowInfo.postCriteriaConfigsdTO]
                : [];

            if (editMode && editGroupIndex !== null) {
                updatedGroups[editGroupIndex] = postCriteriaConfig;
            } else {
                updatedGroups.push(postCriteriaConfig);
            }
            const payload = {
                advertisementId: Number(selectedAdvertNo),
                examId: Number(selectedExam),
                postCriteriaRequired: postSelection === "YES",
                postCriteriaConfigsdTO: updatedGroups

            };
            setLoading(true);
            await dispatch(saveResultFlow(payload));
            await dispatch(getResultFlowInfo(Number(selectedExam)));
            setShowExamModal(false);
            setActiveTest(null);
            resetForm();
        } catch (error) {
            console.error("Save Result Flow Failed", error);
        } finally {
            setLoading(false);
            setEditMode(false);
            setEditGroupIndex(null);
            setEditingGroupId(null);
        }
    };

    useEffect(() => {
        if (postSelection === "YES" && selectedExam) {
            dispatch(getPostCriteriaByExamId(selectedExam));
        }
    }, [postSelection, selectedExam]);

    useEffect(() => {
        if (selectedExam && Number(selectedExam) > 0) {
            dispatch(getResultFlowInfo(Number(selectedExam)));
        }
    }, [selectedExam]);

    useEffect(() => {
        if (postCriteriaList?.length > 0) {
            setDefaultPostCriteriaId(postCriteriaList[0].id);
        }
    }, [postCriteriaList]);

    useEffect(() => {
        dispatch(getExamTypeLookup());
    }, [dispatch]);

    useEffect(() => {
        if (examType === "DESCRIPTIVE") {
            setCutoffMarks({
                finalTotalMarks: "",
                finalCutOff: "",
            });
        }
    }, [examType]);

    useEffect(() => {
        if (!examChecked) {
            setExamType("");
            setTotalMarks("");
            setQualifyingMarks("");
            setQuestionSetRows(
                QUESTION_SETS.map((set) => ({
                    questionSet: set,
                    totalQuestions: "",
                    totalMarks: "",
                    qualifyingMarks: "",
                }))
            );
        }
    }, [examChecked]);

    const isAnyTestSelected =
        examChecked ||
        stages.interview === "YES" ||
        stages.physicalTest === "YES" ||
        stages.medicalTest === "YES" ||
        stages.skillTest === "YES";

    const handlePostChange = (post) => {
        setSelectedPosts((prev) => {
            if (prev.some(p => p.id === post.id)) {
                return prev.filter(p => p.id !== post.id);
            }
            return [...prev, post];
        });
    };

    const resetForm = () => {
        // ===== POST RESET =====
        // setPostSelection("NO");
        setSelectedPosts([]);
        setIsDropdownOpen(false);
        setSelectedPostSubject("");
        setSubjects([]);
        setCategoryList([]);
        setSelectedCategoryId("");
        setCategoryMark("");
        setEditCategoryIndex(null);


        // ===== EXAM / TEST CHECKBOX RESET =====
        setExamChecked(false);
        setActiveTest(null);

        setStages({
            interview: "NO",
            physicalTest: "NO",
            medicalTest: "NO",
            skillTest: "NO",
        });

        // ===== SUBJECT / EXAM RESET =====
        setSubjectCode("");
        setExamType("");
        setSelectedSubject("");
        setSubjectTableData([]);

        // ===== QUESTION SET RESET =====
        setQuestionSetRows(
            QUESTION_SETS.map(set => ({
                questionSet: set,
                totalQuestions: "",
                totalMarks: "",
                qualifyingMarks: ""
            }))
        );

        // ===== MARKS RESET =====
        setPostMarks({ totalMarks: "", qualifyingMarks: "" });
        setInterviewMarks({ totalMarks: "", qualifyingMarks: "" });
        setPhysicalMarks({
            totalMarks: "",
            qualifyingMarks: "",
            height: "",
            chest: "",
            running: "",
        });
        setMedicalMarks({ qualifyingStatus: "PASS" });
        setSkillMarks({ totalMarks: "", qualifyingMarks: "" });

        // ===== OPTIONAL UI RESET =====
        setShowSummaryTable(false);
        setSummaryData(null);
        setSetCount("");
    };

    const cleanPostCriteriaConfigs = selectedPosts
        .filter(post => post && post.id)
        .map(post => ({
            postId: Number(post.id)
        }));

    // const selectedAdvertisement = Array.isArray(allYearList)
    //     ? allYearList.find(
    //         a => String(a.id) === String(resultFlowInfo?.advertisementId)
    //     )
    //     : null;

    const selectedAdvertisement = Array.isArray(resultFlowAdvertisementList)
        ? resultFlowAdvertisementList.find(
            a => String(a.id) === String(resultFlowInfo?.advertisementId)
        )
        : null;

    const selectExam = Array.isArray(examList)
        ? examList.find(
            e => String(e.id) === String(resultFlowInfo?.examId)
        )
        : null;

    const getPostNameById = (postId) => {
        if (!Array.isArray(postCriteriaList)) return "";

        const postObj = postCriteriaList.find(
            p => String(p.id) === String(postId)
        );

        return postObj?.name || "-";
    };

    useEffect(() => {
        if (selectedExam) {
            dispatch(fetchSubjectsByExamAndPost(selectedExam));
        }
    }, [selectedExam]);

    const handleSubjectTypeChange = (type) => {
        if (type === "OBJECTIVE") {
            setCurrentSubject({
                ...currentSubject,
                examType: type,
                examSubjectConfig: []
            });
        } else if (type === "DESCRIPTIVE") {
            setCurrentSubject({
                ...currentSubject,
                examType: type,
                examSubjectConfig: [{
                    totalMarks: "",
                    qualifyingMarks: ""
                }]
            });
        }
    };

    // const handleObjectiveChange = (index, field, value) => {
    //     const updated = [...currentSubject.examSubjectConfig];
    //     updated[index][field] = value;

    //     setCurrentSubject({
    //         ...currentSubject,
    //         examSubjectConfig: updated
    //     });
    // };

    const handleObjectiveChange = (index, field, value) => {
        const updated = [...currentSubject.examSubjectConfig];

        updated[index][field] = value;

        // First row (A) changed -> copy to all rows
        if (index === 0 &&
            (field === "totalQuestions" ||
                field === "totalMarks" ||
                field === "qualifyingMarks")) {

            updated.forEach((row, i) => {
                if (i !== 0) {
                    row[field] = value;
                }
            });
        }

        setCurrentSubject({
            ...currentSubject,
            examSubjectConfig: updated
        });
    };
    const handleDescriptiveChange = (field, value) => {
        const updated = [...currentSubject.examSubjectConfig];
        updated[0][field] = value;

        setCurrentSubject({
            ...currentSubject,
            examSubjectConfig: updated
        });
    };

    const createObjectiveSets = (count) => {
        return Array.from(
            { length: Number(count) || 0 },
            () => ({
                questionSet: "",
                totalQuestions: "",
                totalMarks: "",
                qualifyingMarks: ""
            })
        );
    };

    const handleEditGroup = (group, index) => {

        setEditMode(true);
        setEditGroupIndex(index);
        setEditingGroupId(group.id);

        // Open modal
        setShowExamModal(true);

        // Load posts
        const posts = group.postCriteriaConfigs.map(p => ({
            id: p.postId,
            name: getPostNameById(p.postId)
        }));

        setSelectedPosts(posts);

        // Load Post Marks
        // setPostMarks(group.postMarks || { totalMarks: "", qualifyingMarks: "" });
        setPostMarks({ ...group.postMarks });

        // Load Subjects
        // setSubjects(group.subjects || []);
        setSubjects(JSON.parse(JSON.stringify(group.subjects || [])));

        // Load flags
        setExamChecked(group.examRequired || false);

        setStages({
            interview: group.interviewRequired ? "YES" : "NO",
            physicalTest: group.physicalTestRequired ? "YES" : "NO",
            medicalTest: group.medicalTestRequired ? "YES" : "NO",
            skillTest: group.skillTestRequired ? "YES" : "NO",
        });

        // Load Interview
        if (group.interviewConfig) {
            // setInterviewMarks(group.interviewConfig);
            setInterviewMarks({ ...group.interviewConfig });
        }

        // Load Physical
        if (group.physicalTestConfig) {
            // setPhysicalMarks(group.physicalTestConfig);
            setPhysicalMarks({ ...group.physicalTestConfig });
        }

        // Load Medical
        if (group.medicalTestConfig) {
            setMedicalMarks({
                qualifyingStatus: group.medicalTestConfig.medicalTestQualifyingStatus
            });
        }
        // Load Skill
        if (group.skillTestConfig) {
            // setSkillMarks(group.skillTestConfig);
            setSkillMarks({ ...group.skillTestConfig });
        }
        // Load Subjects
        setSubjects(JSON.parse(JSON.stringify(group.subjects || [])));

        //  LOAD CATEGORY HERE
        if (group.categoryDtoList && group.categoryDtoList.length > 0) {
            const mappedCategories = group.categoryDtoList.map(item => ({
                categoryId: adminCategoriesList?.find(
                    c => c.name.toLowerCase() === item.category.toLowerCase()
                )?.id || "",
                categoryName: item.category,
                mark: item.totalNumber
            }));

            setCategoryList(mappedCategories);
        } else {
            setCategoryList([]);
        }
    };

    const handleEditSubject = (index) => {
        const subjectToEdit = subjects[index];

        // setCurrentSubject(subjectToEdit);
        setCurrentSubject(
            JSON.parse(JSON.stringify(subjectToEdit))
        );
        setEditIndex(index);
        if (subjectToEdit.examType === "OBJECTIVE") {
            setSetCount(subjectToEdit.examSubjectConfig?.length || 0);
        }
    };

    const handleAddSubject = () => {

        //  Required validation
        if (!currentSubject.subjectCode?.trim()) {
            alert("Please enter Subject Code");
            return;
        }
        if (!currentSubject.examType) {
            alert("Please select Subject Type");
            return;
        }

        if (currentSubject.examType === "OBJECTIVE") {

            // Remove completely empty rows (B,C,D if unused)
            const filledRows = currentSubject.examSubjectConfig.filter(
                row => row.totalQuestions || row.totalMarks || row.qualifyingMarks
            );

            // At least one set required
            if (filledRows.length === 0) {
                alert("Please fill at least one Question Set");
                return;
            }

            // Validate only filled rows
            const isInvalid = filledRows.some(
                row => !row.totalQuestions || !row.totalMarks || !row.qualifyingMarks
            );

            if (isInvalid) {
                alert("Please complete all fields of the filled Question Set");
                return;
            }

            // Optional: Save only filled rows
            // currentSubject.examSubjectConfig = filledRows;
            const subjectToSave = {
                ...currentSubject,
                examSubjectConfig: filledRows
            };
        }


        // DESCRIPTIVE extra validation
        if (currentSubject.examType === "DESCRIPTIVE") {
            const row = currentSubject.examSubjectConfig[0];

            if (!row?.totalMarks || !row?.qualifyingMarks) {
                alert("Please fill Descriptive marks");
                return;
            }
        }

        //  Add / Update logic
        if (editIndex !== null) {
            const updated = [...subjects];
            updated[editIndex] = currentSubject;
            setSubjects(updated);
            setEditIndex(null);
        } else {
            // setSubjects([...subjects, currentSubject]);
            setSubjects([
                ...subjects,
                JSON.parse(JSON.stringify(currentSubject))
            ]);
        }
        // Load Category
        // if (group.CategoryDtoList && group.CategoryDtoList.length > 0) {
        //     const mappedCategories = group.CategoryDtoList.map(item => ({
        //         categoryId: adminCategoriesList?.find(
        //             c => c.name.toLowerCase() === item.category.toLowerCase()
        //         )?.id || "",
        //         categoryName: item.category,
        //         mark: item.totalNumber
        //     }));

        //     setCategoryList(mappedCategories);
        // } else {
        //     setCategoryList([]);
        // }


        // Reset
        setCurrentSubject({
            subjectCode: "",
            examType: "",
            examSubjectConfig: []
        });
    };

    const ConfigCard = ({ title, data }) => (
        <div className="border rounded p-2 bg-light small">
            <div className="fw-bold text-center mb-1">{title}</div>

            <div className="d-flex justify-content-between">
                <span>{label.TotalMarks}</span>
                <b>{data.totalMarks}</b>
            </div>

            <div className="d-flex justify-content-between">
                <span>{label.QualifyingMarks}</span>
                <b>{data.qualifyingMarks}</b>
            </div>
        </div>
    );

    const handleAddCategory = () => {
        if (!selectedCategoryId || !categoryMark) return;

        const selectedObj = adminCategoriesList.find(
            cat => String(cat.id) === String(selectedCategoryId)
        );

        if (!selectedObj) return; // important safety

        const newItem = {
            categoryId: selectedObj.id,
            categoryName: selectedObj.name,
            mark: Number(categoryMark)   //  always number
        };

        //  UPDATE MODE
        if (editCategoryIndex !== null) {
            const updatedList = [...categoryList];
            updatedList[editCategoryIndex] = newItem;
            setCategoryList(updatedList);
            setEditCategoryIndex(null);
        }
        //  ADD MODE
        else {
            if (categoryList.some(c => String(c.categoryId) === String(selectedCategoryId))) {
                alert("Category already added");
                return;
            }

            setCategoryList(prev => [...prev, newItem]);
        }

        // Reset
        setSelectedCategoryId("");
        setCategoryMark("");
    };


    const handleEditCategory = (item, index) => {
        setSelectedCategoryId(item.categoryId);
        setCategoryMark(item.mark);
        setEditCategoryIndex(index);
    };

    // ================= SUBJECT-WISE FLOW TRACKER =================

    // Objective Flow Steps
    const objectiveFlowSteps = [
        { key: "flowSetup", label: "Flow Setup" },
        { key: "objection", label: "Objection" },
        { key: "markCalculation", label: "Mark Calc" },
        { key: "seatMatrix", label: "Seat Matrix" },
        { key: "cutOff", label: "Cut-Off" },
        { key: "result", label: "Result" },
    ];

    // Descriptive Flow Steps
    const descriptiveFlowSteps = [
        { key: "flowSetup", label: "Flow Setup" },
        { key: "objection", label: "Objection" },
        { key: "examProcess", label: "Exam Process" },
        { key: "seatMatrix", label: "Seat Matrix" },
        { key: "cutOff", label: "Cut-Off" },
        { key: "result", label: "Result" },
    ];

    const getFlowStepsByType = (examType) => {
        return String(examType).toUpperCase() === "DESCRIPTIVE"
            ? descriptiveFlowSteps
            : objectiveFlowSteps;
    };

    // TEMP STATUS GENERATOR
    // Later replace this with backend response
    const getFlowStatusData = (subject) => {
        const type = String(subject?.examType || "").toUpperCase();

        if (type === "DESCRIPTIVE") {
            return {
                flowSetup: "COMPLETED",
                objection: "COMPLETED",
                examProcess: "PENDING",
                seatMatrix: "NOT_STARTED",
                cutOff: "NOT_STARTED",
                result: "NOT_STARTED",
            };
        }

        return {
            flowSetup: "COMPLETED",
            objection: "COMPLETED",
            markCalculation: "PENDING",
            seatMatrix: "NOT_STARTED",
            cutOff: "NOT_STARTED",
            result: "NOT_STARTED",
        };
    };

    // TEMP SUB STATUS GENERATOR
    const getSubStatusData = (subject) => {
        const type = String(subject?.examType || "").toUpperCase();

        if (type === "DESCRIPTIVE") {
            return {
                objection: [
                    { label: "Absent", status: "COMPLETED" },
                    { label: "Duplicate", status: "COMPLETED" },
                    { label: "Out Of Range", status: "PENDING" },
                    { label: "Version Mismatch", status: "NOT_STARTED" },
                ],
                examProcess: [
                    { label: "Examiner", status: "COMPLETED" },
                    { label: "Moderator", status: "PENDING" },
                    { label: "Chief Moderator", status: "NOT_STARTED" },
                ],
            };
        }

        return {
            objection: [
                { label: "Absent", status: "COMPLETED" },
                { label: "Duplicate", status: "COMPLETED" },
                { label: "Out Of Range", status: "PENDING" },
                { label: "Version Mismatch", status: "NOT_STARTED" },
            ],
        };
    };

    const getStatusClass = (status) => {
        switch (status) {
            case "COMPLETED":
                return "step-completed";
            case "PENDING":
            case "IN_PROGRESS":
                return "step-pending";
            case "FAILED":
            case "REJECTED":
                return "step-failed";
            default:
                return "step-not-started";
        }
    };

    const getStatusIcon = (status, index) => {
        switch (status) {
            case "COMPLETED":
                return "✓";
            case "PENDING":
            case "IN_PROGRESS":
                return "!";
            case "FAILED":
            case "REJECTED":
                return "✕";
            default:
                return index + 1;
        }
    };

    const getOverallFlowStatus = (flowStatusData) => {
        const statuses = Object.values(flowStatusData);

        if (statuses.every((s) => s === "COMPLETED")) return "COMPLETED";
        if (statuses.some((s) => s === "PENDING" || s === "IN_PROGRESS"))
            return "IN_PROGRESS";
        if (statuses.some((s) => s === "COMPLETED")) return "PARTIAL";
        return "NOT_STARTED";
    };

    // Flatten all subjects from groups
    const allSubjects =
        Array.isArray(resultFlowInfo?.postCriteriaConfigsdTO)
            ? resultFlowInfo.postCriteriaConfigsdTO.flatMap((group) =>
                Array.isArray(group.subjects)
                    ? group.subjects.map((sub) => ({
                        ...sub,
                        groupName: group.postCriteriaConfigs
                            ?.map((p) => getPostNameById(p.postId))
                            .join(", "),
                    }))
                    : []
            )
            : [];
    return (
        <>
            <div className="commonContentArea">
                <div className="row dashboardCards">
                    <div className="col-md-12">
                        <div className="form-group importFromSection">
                            <div className="row">
                                <>
                                    <div className="form-group col-md-2">
                                        <label className="float-left">
                                            {label.Year}
                                            <span className="errorText">*</span>
                                        </label>
                                        <select
                                            className="form-control"
                                            name="selectedYear"
                                            onChange={(e) => onSelectYear(e.target.value)}
                                        >
                                            <option value="">{label.COMBO_SELECT}</option>
                                            {/* 
                                            {yearList &&
                                                yearList.map((year, index) => (
                                                    <option key={index} value={year}>
                                                        {year}
                                                    </option>
                                                ))} */}
                                            {resultFlowYearList &&
                                                resultFlowYearList.map((year, index) => (
                                                    <option key={index} value={year}>
                                                        {year}
                                                    </option>
                                                ))}
                                        </select>

                                        {/* {_.get("selectedYear.type", errors) ===
                                        "required" && (
                                            <p className="errorText float-left">
                                                {label.MANDATORY_FIELD_MESSAGE}
                                            </p>
                                        )} */}
                                    </div>

                                    <div className="form-group col-md-4">
                                        <label className="float-left">
                                            {label.Advertisement}
                                            <span className="errorText">*</span>
                                        </label>
                                        <select
                                            className="form-control"
                                            name="selectedAdvertiseNo"
                                            // ref={register({ required: true })}
                                            onChange={(e) => {
                                                onAdvertisementChange(e.target.value);
                                            }}
                                        >
                                            <option key={0} value="">
                                                {label.COMBO_SELECT}
                                            </option>
                                            {/* {allYearList &&
                                                allYearList.length > 0 &&
                                                allYearList.map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                                    </option>
                                                ))} */}
                                            {resultFlowAdvertisementList &&
                                                resultFlowAdvertisementList.length > 0 &&
                                                resultFlowAdvertisementList.map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                                    </option>
                                                ))}

                                        </select>
                                        {/* {_.get("selectedAdvertiseNo.type", errors) ===
                                            "required" && (
                                                <p className="errorText float-left">
                                                    {label.MANDATORY_FIELD_MESSAGE}
                                                </p>
                                            )} */}
                                    </div>

                                    {/* Select Exam */}
                                    <div className="form-group col-md-3">
                                        <label className="float-left">
                                            {label.Exam}
                                            <span className="errorText">*</span>
                                        </label>
                                        <select
                                            className="form-control"
                                            value={selectedExam}
                                            onChange={(e) => onExamChange(e.target.value)}
                                        >
                                            <option value="">
                                                {label.COMBO_SELECT}
                                            </option>

                                            {examList &&
                                                examList.map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {element.name}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>

                                    {/* Post Selection */}
                                    <div className="form-group col-md-3">
                                        <label>Post Selection</label>
                                        <select
                                            className="form-control"
                                            value={postSelection}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setPostSelection(value);
                                                // reset subject
                                                setSelectedSubject("");
                                                // subjectList.length = 0;
                                                // when NO → load normal subjects
                                                if (value === "NO" && selectedExam) {
                                                    dispatch(getSubjectlistByExamId(selectedExam));
                                                }
                                            }}
                                        >
                                            <option value="YES">YES</option>
                                            <option value="NO">NO</option>
                                        </select>
                                    </div>

                                    {postSelection === "YES" && (
                                        <div className="row ml-2px">
                                            {/* LEFT: DROPDOWN */}
                                            <div className="col-md-6">
                                                <label>
                                                    {/* Post Name  */}
                                                    {label.PostName}
                                                    <span className="errorText">*</span>
                                                </label>
                                                <div
                                                    className="form-control d-flex justify-content-between align-items-center  cursor-pointer"
                                                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                                >
                                                    <span>
                                                        {selectedPosts.length > 0
                                                            ? `${selectedPosts.length} post(s) selected`
                                                            : "Select Post"}
                                                    </span>
                                                    <span>▾</span>
                                                </div>

                                                {isDropdownOpen && (
                                                    <div
                                                        className="border p-2 scroll-post-list"
                                                    >
                                                        {postCriteriaList?.map((post) => (
                                                            <div className="form-check" key={post.id}>
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    checked={selectedPosts.some(p => p.id === post.id)}
                                                                    onChange={() => handlePostChange(post)}   //  full object
                                                                />
                                                                <label className="form-check-label">
                                                                    {post.name}
                                                                </label>
                                                            </div>
                                                        ))}

                                                    </div>
                                                )}
                                            </div>

                                            <div className="col-md-6">
                                                <label>{label.selectedPosts}</label>

                                                {selectedPosts.length === 0 ? (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value="No post selected"
                                                        readOnly
                                                    />
                                                ) : (
                                                    <>
                                                        {/* GROUP NAME */}
                                                        <div className="fw-bold mb-2 mt-1">
                                                            Group-1
                                                        </div>

                                                        {/* POSTS UNDER GROUP */}
                                                        {selectedPosts.map((post) => (
                                                            <input
                                                                key={post.id}
                                                                type="text"
                                                                className="form-control mb-2"
                                                                value={post.name}   //  now name exists
                                                                readOnly
                                                            />
                                                        ))}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {postSelection === "YES" && selectedPosts.length > 0 && (
                                        <div className="row mb-3 ml-3">
                                            <div className="col-md-12">
                                                <label className="fw-bold mb-2">{label.TestCriteria}</label>
                                                <div className="row d-flex flex-nowrap ">
                                                    <div className="col-md-3">
                                                        <div className="d-flex justify-content-around me-1">
                                                            <input
                                                                type="checkbox"
                                                                checked={examChecked}
                                                                onChange={(e) => {
                                                                    const checked = e.target.checked;
                                                                    setExamChecked(checked);
                                                                    if (checked) {
                                                                        setActiveTest("EXAM");
                                                                        setShowExamModal(true);
                                                                    }
                                                                }}
                                                            />
                                                            <span>{label.Exam_Screening_Test}</span>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="d-flex justify-content-center">

                                                            <input
                                                                type="checkbox"
                                                                checked={stages.interview === "YES"}
                                                                onChange={(e) => {
                                                                    const checked = e.target.checked;
                                                                    setStages(prev => ({ ...prev, interview: checked ? "YES" : "NO" }));
                                                                    if (checked) {
                                                                        setActiveTest("INTERVIEW");
                                                                        setShowExamModal(true);
                                                                    }
                                                                }}
                                                            />
                                                            <span className="ml-1">{label.Interview}</span>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="d-flex justify-content-around">
                                                            <input
                                                                type="checkbox"
                                                                checked={stages.physicalTest === "YES"}
                                                                onChange={(e) => {
                                                                    const checked = e.target.checked;
                                                                    setStages(prev => ({ ...prev, physicalTest: checked ? "YES" : "NO" }));
                                                                    if (checked) {
                                                                        setActiveTest("PHYSICAL");
                                                                        setShowExamModal(true);
                                                                    }
                                                                }}
                                                            />

                                                            <span>{label.PhysicalTest}</span>

                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="d-flex justify-content-around ">
                                                            <input
                                                                type="checkbox"
                                                                checked={stages.medicalTest === "YES"}
                                                                onChange={(e) => {
                                                                    const checked = e.target.checked;
                                                                    setStages(prev => ({ ...prev, medicalTest: checked ? "YES" : "NO" }));
                                                                    if (checked) {
                                                                        setActiveTest("MEDICAL");
                                                                        setShowExamModal(true);
                                                                    }
                                                                }}
                                                            />
                                                            <span>{label.MedicalTest}</span>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-3">
                                                        <div className="d-flex justify-content-center">
                                                            <input
                                                                type="checkbox"
                                                                checked={stages.skillTest === "YES"}
                                                                onChange={(e) => {
                                                                    const checked = e.target.checked;
                                                                    setStages(prev => ({ ...prev, skillTest: checked ? "YES" : "NO" }));
                                                                    if (checked) {
                                                                        setActiveTest("SKILL");
                                                                        setShowExamModal(true);
                                                                    }
                                                                }}
                                                            />
                                                            <span className="ml-1">{label.SkillTest}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {showExamModal && (
                                        <div className="modal fade show d-block" tabIndex="-1">
                                            <div className="modal-dialog modal-lg modal-dialog-centered">
                                                <div className="modal-content modal-scroll">

                                                    {/* HEADER */}
                                                    <div className="modal-header">
                                                        <h5 className="modal-title">{label.Configuration}</h5>
                                                        <button
                                                            type="button"
                                                            className="close"
                                                            onClick={() => {
                                                                setShowExamModal(false);
                                                            }}
                                                        >
                                                            ×
                                                        </button>
                                                    </div>

                                                    {/* BODY */}
                                                    <div className="modal-body">

                                                        {/* ================= POST MARKS (ALWAYS) ================= */}
                                                        <div className="border rounded p-2 mb-3">
                                                            <h6 className="fw-bold text-primary mb-3">
                                                                {label.PostMarksConfiguration}
                                                            </h6>

                                                            <div className="row">
                                                                <div className="col-md-2">
                                                                    <label>{label.TotalMarks}*</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control form-control-sm"
                                                                        value={postMarks.totalMarks}
                                                                        onChange={(e) =>
                                                                            setPostMarks({
                                                                                ...postMarks,
                                                                                totalMarks: e.target.value,
                                                                            })
                                                                        }
                                                                    />
                                                                </div>

                                                                <div className="col-md-3">
                                                                    <label>{label.QualifyingMarks}*</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control form-control-sm"
                                                                        value={postMarks.qualifyingMarks}
                                                                        onChange={(e) =>
                                                                            setPostMarks({
                                                                                ...postMarks,
                                                                                qualifyingMarks: e.target.value,
                                                                            })
                                                                        }
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* ================= EXAM ================= */}
                                                        {examChecked && (
                                                            <>
                                                                {/* SUBJECT */}
                                                                <div className="border rounded p-2 mb-3">
                                                                    <h6 className="mb-3">Subject</h6>

                                                                    <div className="border rounded p-3 mb-3">
                                                                        <h6 className="fw-bold mb-3">{label.SubjectConfiguration}</h6>

                                                                        <div className="row align-items-end">

                                                                            <div className="col-md-3">
                                                                                <label>{label.Subject}*</label>

                                                                                <select
                                                                                    className="form-control"
                                                                                    value={currentSubject.subjectName || ""}
                                                                                    onChange={(e) => {
                                                                                        const fullString = e.target.value;

                                                                                        const codeMatch = fullString.match(/\((.*?)\)/);
                                                                                        const extractedCode = codeMatch ? codeMatch[1] : "";

                                                                                        setCurrentSubject({
                                                                                            ...currentSubject,
                                                                                            subjectCode: extractedCode,
                                                                                            subjectName: fullString
                                                                                        });
                                                                                    }}
                                                                                >
                                                                                    <option value="">{label.SelectSubject}</option>

                                                                                    {subjectListPost?.map((subject, index) => (
                                                                                        <option key={index} value={subject}>
                                                                                            {subject.replace(/\(/g, " (")}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            </div>

                                                                            <div className="col-md-3">
                                                                                <label>{label.SubjectType} *</label>
                                                                                <select
                                                                                    className="form-control"
                                                                                    value={currentSubject.examType}
                                                                                    onChange={(e) => handleSubjectTypeChange(e.target.value)}
                                                                                >
                                                                                    <option value="">Select</option>
                                                                                    <option value="OBJECTIVE">Objective</option>
                                                                                    <option value="DESCRIPTIVE">Descriptive</option>
                                                                                </select>
                                                                            </div>

                                                                            {currentSubject.examType === "OBJECTIVE" && (
                                                                                <div className="col-md-2">
                                                                                    <label>Set Count *</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control"
                                                                                        value={setCount}
                                                                                        onChange={(e) => {
                                                                                            const count = e.target.value;

                                                                                            setSetCount(count);

                                                                                            setCurrentSubject(prev => ({
                                                                                                ...prev,
                                                                                                examSubjectConfig: createObjectiveSets(count)
                                                                                            }));
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            )}
                                                                            <div className="d-flex mb-3">
                                                                                <button
                                                                                    className="btn btn-success"
                                                                                    onClick={handleAddSubject}
                                                                                    disabled={!currentSubject.subjectCode || !currentSubject.examType}
                                                                                >
                                                                                    {editIndex !== null ? "Update" : "Add"}

                                                                                </button>
                                                                            </div>
                                                                        </div>

                                                                        {/* ================= OBJECTIVE ================= */}
                                                                        {currentSubject.examType === "OBJECTIVE" && (
                                                                            <table className="table table-bordered mt-3">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>{label.Set}</th>
                                                                                        <th>{label.TotalQuestions}</th>
                                                                                        <th>{label.TotalMarks}</th>
                                                                                        <th>{label.QualifyingMarks}</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {currentSubject.examSubjectConfig.map((row, index) => (
                                                                                        <tr key={index}>
                                                                                            <td>
                                                                                                <input
                                                                                                    type="text"
                                                                                                    className="form-control"
                                                                                                    value={row.questionSet}
                                                                                                    onChange={(e) =>
                                                                                                        handleObjectiveChange(index, "questionSet", e.target.value)
                                                                                                    }
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="form-control"
                                                                                                    value={row.totalQuestions}
                                                                                                    onChange={(e) =>
                                                                                                        handleObjectiveChange(index, "totalQuestions", e.target.value)
                                                                                                    }
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="form-control"
                                                                                                    value={row.totalMarks}
                                                                                                    onChange={(e) =>
                                                                                                        handleObjectiveChange(index, "totalMarks", e.target.value)
                                                                                                    }
                                                                                                />
                                                                                            </td>
                                                                                            <td>
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="form-control"
                                                                                                    value={row.qualifyingMarks}
                                                                                                    onChange={(e) =>
                                                                                                        handleObjectiveChange(index, "qualifyingMarks", e.target.value)
                                                                                                    }
                                                                                                />
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        )}

                                                                        {/* ================= DESCRIPTIVE ================= */}
                                                                        {currentSubject.examType === "DESCRIPTIVE" && (
                                                                            <div className="row mt-3">
                                                                                <div className="col-md-3">
                                                                                    <label>{label.TotalMarks}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control"
                                                                                        value={currentSubject.examSubjectConfig[0]?.totalMarks || ""}
                                                                                        onChange={(e) =>
                                                                                            handleDescriptiveChange("totalMarks", e.target.value)
                                                                                        }
                                                                                    />
                                                                                </div>

                                                                                <div className="col-md-3">
                                                                                    <label>{label.QualifyingMarks}</label>
                                                                                    <input
                                                                                        type="number"
                                                                                        className="form-control"
                                                                                        value={currentSubject.examSubjectConfig[0]?.qualifyingMarks || ""}
                                                                                        onChange={(e) =>
                                                                                            handleDescriptiveChange("qualifyingMarks", e.target.value)
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                        {/* ================= ADDED SUBJECTS ================= */}
                                                                        {subjects.length > 0 && (
                                                                            <div className="mt-4">
                                                                                <h6 className="fw-bold">{label.AddedSubjects}</h6>

                                                                                {subjects.map((sub, i) => (
                                                                                    <div key={i} className="border rounded p-2 mb-2 bg-light d-flex justify-content-between align-items-center">
                                                                                        <div>
                                                                                            <div><b>Code:</b> {sub.subjectCode}</div>
                                                                                            <div><b>Type:</b> {sub.examType}</div>
                                                                                        </div>

                                                                                        <button
                                                                                            className="btn btn-sm btn-primary"
                                                                                            onClick={() => handleEditSubject(i)}
                                                                                        >
                                                                                            {label.Edit}
                                                                                        </button>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    {/* ================= CATEGORY SECTION ================= */}

                                                                    {/* <div className="border rounded p-3 mt-3 bg-light">
                                                                        <h6 className="fw-bold mb-3">Category Configuration</h6>

                                                                        <div className="row align-items-end">
                                                                            <div className="col-md-4">
                                                                                <label className="form-label">Category</label>
                                                                                <select
                                                                                    className="form-control"
                                                                                    value={selectedCategoryId}
                                                                                    onChange={(e) => setSelectedCategoryId(e.target.value)}
                                                                                >
                                                                                    <option value="">Select Category</option>

                                                                                    {adminCategoriesList?.map((cat) => (
                                                                                        <option key={cat.id} value={cat.id}>
                                                                                            {cat.name}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>

                                                                            </div>

                                                                            <div className="col-md-4">
                                                                                <label className="form-label">Mark</label>
                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control"
                                                                                    value={categoryMark}
                                                                                    onChange={(e) => setCategoryMark(e.target.value)}
                                                                                    disabled={!selectedCategoryId}
                                                                                />
                                                                            </div>
                                                                           
                                                                            <div className="col-md-2">
                                                                                <button
                                                                                    className="btn btn-success w-100 mb-3"
                                                                                    onClick={handleAddCategory}
                                                                                    disabled={!selectedCategoryId || !categoryMark}
                                                                                >
                                                                                    {editCategoryIndex !== null ? "Update" : "Add"}
                                                                                </button>

                                                                            </div>

                                                                        </div>
                                                                        
                                                                        {categoryList.length > 0 && (
                                                                            <div className="mt-4">
                                                                                <h6 className="fw-bold mb-2">Added Categories</h6>

                                                                                <div className="table-responsive">
                                                                                    <table className="table table-bordered table-sm">
                                                                                        <thead className="table-light">
                                                                                            <tr>
                                                                                                <th>Category</th>
                                                                                                <th>Mark</th>
                                                                                                <th>Action</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {categoryList.map((item, index) => (
                                                                                                <tr key={index}>
                                                                                                    <td>{item.categoryName}</td>
                                                                                                    <td>{item.mark}</td>
                                                                                                    <td>
                                                                                                        <button
                                                                                                            className="btn btn-sm btn-primary "
                                                                                                            onClick={() => handleEditCategory(item, index)}
                                                                                                        >
                                                                                                            Edit
                                                                                                        </button>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div> */}
                                                                </div>

                                                                {/* OBJECTIVE */}
                                                                {examType?.toUpperCase() === "OBJECTIVE" && (
                                                                    <div className="mt-3">
                                                                        <h6 className="fw-bold text-primary">{label.DefineOptionCodes}</h6>
                                                                        <table className="table table-bordered table-sm">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>{label.questionSet}</th>
                                                                                    <th>{label.TotalQuestions}</th>
                                                                                    <th>{label.TotalMarks}</th>
                                                                                    <th>{label.QualifyingMarks}</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {questionSetRows.map((row, index) => (
                                                                                    <tr key={index}>
                                                                                        {/* Question Set (A/B/C/D) */}
                                                                                        <td>
                                                                                            <input
                                                                                                className="form-control form-control-sm"
                                                                                                value={row.questionSet}
                                                                                                disabled
                                                                                            />
                                                                                        </td>

                                                                                        {/* Total Questions */}
                                                                                        <td>
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control form-control-sm"
                                                                                                value={row.totalQuestions}
                                                                                                onChange={(e) =>
                                                                                                    handleQuestionSetChange(index, "totalQuestions", e.target.value)
                                                                                                }
                                                                                            />
                                                                                        </td>

                                                                                        {/* Total Marks */}
                                                                                        <td>
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control form-control-sm"
                                                                                                value={row.totalMarks}
                                                                                                onChange={(e) =>
                                                                                                    handleQuestionSetChange(index, "totalMarks", e.target.value)
                                                                                                }
                                                                                            />
                                                                                        </td>

                                                                                        {/* Qualifying Marks */}
                                                                                        <td>
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control form-control-sm"
                                                                                                value={row.qualifyingMarks}
                                                                                                onChange={(e) =>
                                                                                                    handleQuestionSetChange(index, "qualifyingMarks", e.target.value)
                                                                                                }
                                                                                            />
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                )}

                                                                {/* DESCRIPTIVE */}
                                                                {examType?.toUpperCase() === "DESCRIPTIVE" && (
                                                                    <div className="mt-3">
                                                                        <h6 className="fw-bold text-primary">{label.MarksConfiguration}</h6>
                                                                        <table className="table table-bordered w-50">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th>{label.TotalMarks}</th>
                                                                                    <th>{label.QualifyingMarks}</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="form-control"
                                                                                            value={totalMarks}
                                                                                            onChange={(e) => setTotalMarks(e.target.value)}
                                                                                        />
                                                                                    </td>
                                                                                    <td>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="form-control"
                                                                                            value={qualifyingMarks}
                                                                                            onChange={(e) => setQualifyingMarks(e.target.value)}
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                )}
                                                            </>
                                                        )}

                                                        {/* ================= INTERVIEW ================= */}
                                                        {stages.interview === "YES" && (
                                                            <div className="border rounded p-2 mb-3">
                                                                <h6 className="fw-bold text-primary mb-3">
                                                                    {label.InterviewConfiguration}
                                                                </h6>

                                                                <div className="row">
                                                                    <div className="col-md-3">
                                                                        <label>{label.TotalMarks}*</label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm"
                                                                            value={interviewMarks.totalMarks}
                                                                            onChange={(e) =>
                                                                                setInterviewMarks({
                                                                                    ...interviewMarks,
                                                                                    totalMarks: e.target.value,
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>

                                                                    <div className="col-md-3">
                                                                        <label>{label.QualifyingMarks}*</label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm"
                                                                            value={interviewMarks.qualifyingMarks}
                                                                            onChange={(e) =>
                                                                                setInterviewMarks({
                                                                                    ...interviewMarks,
                                                                                    qualifyingMarks: e.target.value,
                                                                                })
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                        {/* ================= PHYSICAL ================= */}
                                                        {stages.physicalTest === "YES" && (
                                                            <div className="border rounded p-2 mb-3">
                                                                <h6 className="fw-bold text-primary mb-3">
                                                                    {label.PhysicalTestConfiguration}
                                                                </h6>

                                                                <div className="row">
                                                                    <div className="col-md-3">
                                                                        <label>{label.TotalMarks} *</label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm"
                                                                            value={physicalMarks.totalMarks}
                                                                            onChange={(e) =>
                                                                                setPhysicalMarks({ ...physicalMarks, totalMarks: e.target.value })
                                                                            }
                                                                        />
                                                                    </div>

                                                                    <div className="col-md-3">
                                                                        <label>{label.QualifyingMarks}*</label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm"
                                                                            value={physicalMarks.qualifyingMarks}
                                                                            onChange={(e) =>
                                                                                setPhysicalMarks({ ...physicalMarks, qualifyingMarks: e.target.value })
                                                                            }
                                                                        />
                                                                    </div>

                                                                    <div className="col-md-2">
                                                                        <label>{label.Height}</label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm"
                                                                            value={physicalMarks.height}
                                                                            onChange={(e) =>
                                                                                setPhysicalMarks({ ...physicalMarks, height: e.target.value })
                                                                            }
                                                                        />
                                                                    </div>

                                                                    <div className="col-md-2">
                                                                        <label>{label.Chest}</label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm"
                                                                            value={physicalMarks.chest}
                                                                            onChange={(e) =>
                                                                                setPhysicalMarks({ ...physicalMarks, chest: e.target.value })
                                                                            }
                                                                        />
                                                                    </div>

                                                                    <div className="col-md-2">
                                                                        <label>{label.Running}</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control form-control-sm"
                                                                            value={physicalMarks.running}
                                                                            onChange={(e) =>
                                                                                setPhysicalMarks({ ...physicalMarks, running: e.target.value })
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {stages.medicalTest === "YES" && (
                                                            <div className="border rounded p-2 mb-3">
                                                                <h6 className="fw-bold text-primary mb-3">
                                                                    {label.MedicalTestConfiguration}
                                                                </h6>

                                                                <div className="row">
                                                                    <div className="col-md-4">
                                                                        <label className="mb-1">
                                                                            {label.QualifyingStatus}
                                                                            <span className="errorText">*</span>
                                                                        </label>

                                                                        <select
                                                                            className="form-control form-control-sm"
                                                                            value={medicalMarks.qualifyingStatus}
                                                                            onChange={(e) =>
                                                                                setMedicalMarks({
                                                                                    ...medicalMarks,
                                                                                    qualifyingStatus: e.target.value,
                                                                                })
                                                                            }
                                                                        >
                                                                            <option value="">{label.SelectStatus}</option>
                                                                            <option value="PASS">PASS</option>
                                                                            <option value="FAIL">FAIL</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* ================= SKILL ================= */}
                                                        {stages.skillTest === "YES" && (
                                                            <div className="border rounded p-2 mb-3">
                                                                <h6 className="fw-bold text-primary mb-3">
                                                                    {label.SkillTestConfiguration}
                                                                </h6>

                                                                <div className="row">
                                                                    <div className="col-md-3">
                                                                        <label> {label.TotalMarks}*</label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm"
                                                                            value={skillMarks.totalMarks}
                                                                            onChange={(e) =>
                                                                                setSkillMarks({ ...skillMarks, totalMarks: e.target.value })
                                                                            }
                                                                        />
                                                                    </div>

                                                                    <div className="col-md-3">
                                                                        <label>{label.QualifyingMarks} *</label>
                                                                        <input
                                                                            type="number"
                                                                            className="form-control form-control-sm"
                                                                            value={skillMarks.qualifyingMarks}
                                                                            onChange={(e) =>
                                                                                setSkillMarks({ ...skillMarks, qualifyingMarks: e.target.value })
                                                                            }
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* FOOTER */}
                                                    <div className="modal-footer">
                                                        <button
                                                            className="btn btn-secondary"
                                                            onClick={() => setShowExamModal(false)}
                                                        >
                                                            {label.Close}
                                                        </button>
                                                        <button
                                                            className="btn btn-primary"
                                                            onClick={handleSave}
                                                            disabled={loading}
                                                        >
                                                            {loading ? "Saving..." : "Save"}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            </div>
                            {/* ================= SUBJECT-WISE FLOW TRACKERS ================= */}
                            {/* {allSubjects.map((subject, subjectIndex) => {
                                const flowSteps = getFlowStepsByType(subject.examType);
                                const flowStatusData = getFlowStatusData(subject);
                                const subStatusData = getSubStatusData(subject);
                                const overallFlowStatus = getOverallFlowStatus(flowStatusData);

                                return (
                                    <div
                                        key={`${subject.subjectCode}-${subjectIndex}`}
                                        className="card shadow-sm border-0 mb-3 result-flow-stepper-card compact-tracker-card"
                                    >
                                        <div className="subject-flow-header px-3 pt-3 pb-2 border-bottom">
                                            <div className="d-flex justify-content-between align-items-start flex-wrap gap-2">
                                                <div>
                                                    <h6 className="mb-1 fw-bold subject-title">
                                                        Subject: {subject.subjectCode || `Subject ${subjectIndex + 1}`}
                                                    </h6>

                                                    <div className="d-flex align-items-center flex-wrap gap-2">
                                                        <span
                                                            className={`badge px-2 py-1 subject-type-badge ${String(subject.examType).toUpperCase() === "OBJECTIVE"
                                                                    ? "bg-primary"
                                                                    : "bg-info text-dark"
                                                                }`}
                                                        >
                                                            {subject.examType}
                                                        </span>
                                                    </div>
                                                </div>

                                                <span
                                                    className={`badge px-3 py-2 flow-status-badge ${overallFlowStatus === "COMPLETED"
                                                            ? "bg-success"
                                                            : overallFlowStatus === "IN_PROGRESS"
                                                                ? "bg-warning text-dark"
                                                                : overallFlowStatus === "PARTIAL"
                                                                    ? "bg-info text-white"
                                                                    : "bg-secondary"
                                                        }`}
                                                >
                                                    {overallFlowStatus.replace("_", " ")}
                                                </span>
                                            </div>

                                            {subject.groupName && (
                                                <div className="post-group-text mt-2 small text-muted">
                                                    <strong>Post Group:</strong> {subject.groupName}
                                                </div>
                                            )}
                                        </div>

                                        <div className="px-3 py-3">
                                            <div className="result-stepper-wrapper compact-stepper">
                                                {flowSteps.map((step, index) => {
                                                    const status = flowStatusData[step.key];
                                                    const subCount = subStatusData[step.key]?.length || 0;

                                                    return (
                                                        <React.Fragment key={step.key}>
                                                            <div className="stepper-step compact-step">
                                                                <div className={`step-circle ${getStatusClass(status)}`}>
                                                                    {getStatusIcon(status, index)}
                                                                </div>

                                                                <div className="step-label mt-2">{step.label}</div>
                                                                <div className="step-status-text small">
                                                                    {status.replace("_", " ")}
                                                                </div>

                                                                {subCount > 0 && (
                                                                    <div className="step-sub-count mt-1">
                                                                        {subCount} Checks
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {index !== flowSteps.length - 1 && (
                                                                <div
                                                                    className={`step-line ${status === "COMPLETED"
                                                                            ? "line-completed"
                                                                            : "line-pending"
                                                                        }`}
                                                                />
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </div>

                                            <div className="compact-sub-status-section mt-3">
                                                {Object.keys(subStatusData).map((key) => (
                                                    <div key={key} className="mb-2">
                                                        <div className="small fw-semibold text-muted mb-1">
                                                            {flowSteps.find((s) => s.key === key)?.label}
                                                        </div>
                                                        <div className="d-flex flex-wrap gap-2">
                                                            {subStatusData[key].map((item, subIndex) => (
                                                                <span
                                                                    key={subIndex}
                                                                    className={`sub-status-chip compact-chip ${getStatusClass(item.status)}`}
                                                                >
                                                                    {item.label}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}  */}
                            {showResultTable && (
                                <div className="row mb-3">
                                    <div className="col-md-12">
                                        <div className="card p-2 ">
                                            {/* Advertisement below Exam */}
                                            <div>
                                                <div className="text-muted"> <b>{label.Advertisement}:</b>
                                                    {selectedAdvertisement?.description || "-"}  </div>
                                            </div>
                                            <hr />
                                            {/* Exam on top */}
                                            <div className="mb-2">
                                                <div className="text-muted">
                                                    <b>{label.Exam} : </b>
                                                    {selectExam?.name || "-"} </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {Array.isArray(resultFlowInfo?.postCriteriaConfigsdTO) &&
                                resultFlowInfo.postCriteriaConfigsdTO.length > 0 && (

                                    <table className="table table-bordered result-flow-table">
                                        <thead className="table-light">
                                            <tr>
                                                <th>{label.ExamAndSubject}</th>
                                                <th>{label.Interview}</th>
                                                <th>{label.PhysicalTest}</th>
                                                <th>{label.MedicalTest}</th>
                                                <th>{label.SkillTest}</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {resultFlowInfo?.postCriteriaConfigsdTO?.map((group, groupIndex) => (
                                                <React.Fragment key={group.postCriteriaConfigs?.map(p => p.postId).join("-")}>

                                                    {/* ===== POST GROUP HEADER ===== */}

                                                    <tr>
                                                        <td colSpan={5} className="bg-secondary bg-opacity-10 fw-bold py-2">
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <span className="text-white ">Post Group {groupIndex + 1}</span>

                                                                <button
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={() => handleEditGroup(group, groupIndex)}
                                                                >
                                                                    {label.Edit}
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    {Array.isArray(group.subjects) && group.subjects.length > 0 ? (
                                                        <>
                                                            {/* ================= GROUP HEADER ROW ================= */}
                                                            <tr className="bg-light">
                                                                <td colSpan={5} className="fw-bold text-primary">
                                                                    {group.postCriteriaConfigs
                                                                        ?.map(p => getPostNameById(p.postId))
                                                                        .join(", ")}
                                                                </td>
                                                            </tr>

                                                            {/* ================= SUBJECT ROWS ================= */}
                                                            {group.subjects.map((sub, index) => (
                                                                <tr key={`${groupIndex}-${sub.subjectCode || index}`}>

                                                                    {/* ===== SUBJECT COLUMN ONLY ===== */}
                                                                    <td className="align-top">

                                                                        {/* Subject Code */}
                                                                        {sub.subjectCode && (
                                                                            <div className="small text-muted mb-1">
                                                                                <b>
                                                                                    {label.SubjectCode}:{" "}
                                                                                </b>
                                                                                {sub.subjectCode}/{sub.subjectName}
                                                                            </div>
                                                                        )}

                                                                        {/* Exam Type Badge */}
                                                                        {sub.examType && (
                                                                            <span className="badge bg-info mb-2">
                                                                                {sub.examType}
                                                                            </span>
                                                                        )}

                                                                        {/* ===== CATEGORY DISTRIBUTION ===== */}
                                                                        {index === 0 && group.categoryDtoList?.length > 0 && (
                                                                            <div className="border rounded p-2 mt-2 bg-light small w-50">                                                                        <div className="fw-bold mb-1">{label.CategoryMark}</div>

                                                                                {group.categoryDtoList.map((cat, i) => (
                                                                                    <div key={i} className="d-flex justify-content-between">
                                                                                        <span>{cat.category}</span>
                                                                                        <b>{cat.totalNumber}</b>
                                                                                    </div>
                                                                                ))}
                                                                            </div>
                                                                        )}

                                                                        {/* Post Marks (show once visually but safe here) */}
                                                                        {/* {index === 0 && group.postMarks && (

                                                                            <div className="border rounded p-2 mt-2 bg-light small" style={{ maxWidth: "200px" }}>
                                                                                <div>Posts Mark</div>
                                                                                <div>Total Marks: <b>{group.postMarks.totalMarks}</b></div>
                                                                                <div>Qualifying: <b>{group.postMarks.qualifyingMarks}</b></div>
                                                                            </div>
                                                                        )} */}

                                                                        {index === 0 && group.postMarks && (
                                                                            <div
                                                                                className="border rounded p-2 mt-2 bg-light small fixed-des-mark"
                                                                            >
                                                                                <div className="fw-bold mb-2">{label.postMarks}</div>

                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>{label.TotalMarks}</span>
                                                                                    <b>{group.postMarks.totalMarks}</b>
                                                                                </div>

                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>{label.QualifyingMarks}</span>
                                                                                    <b>{group.postMarks.qualifyingMarks}</b>
                                                                                </div>
                                                                            </div>
                                                                        )}


                                                                        {/* ===== OBJECTIVE ===== */}

                                                                        {String(sub.examType).toUpperCase() === "OBJECTIVE" && (
                                                                            <div className="mt-3 w-60">
                                                                                <div className="fw-bold mb-2">
                                                                                    {label.ObjectiveQuestionSets}
                                                                                </div>

                                                                                <div className="border rounded bg-light small fixed-obj-table">

                                                                                    {/* Header Row */}
                                                                                    <div className="d-flex text-center border-bottom fw-bold py-2">
                                                                                        <div className="col-3">Set</div>
                                                                                        <div className="col-3" >Q</div>
                                                                                        <div className="col-3">T.M</div>
                                                                                        <div className="col-3">Q.M</div>
                                                                                    </div>

                                                                                    {/* Data Rows */}
                                                                                    {sub.examSubjectConfig?.map((qs, i) => (
                                                                                        <div
                                                                                            key={i}
                                                                                            className={`d-flex text-center py-2 ${i !== sub.examSubjectConfig.length - 1 ? "border-bottom" : ""
                                                                                                }`}
                                                                                        >
                                                                                            <div className="col-3">{qs.questionSet}</div>
                                                                                            <div className="col-3">{qs.totalQuestions}</div>
                                                                                            <div className="col-3">{qs.totalMarks}</div>
                                                                                            <div className="col-3">{qs.qualifyingMarks}</div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                        {/* ===== DESCRIPTIVE ===== */}

                                                                        {String(sub.examType).toUpperCase() === "DESCRIPTIVE" && (
                                                                            <div
                                                                                className="border rounded p-2 mt-2 bg-light small fixed-des-mark"

                                                                            >
                                                                                <div className="fw-bold mb-2">{label.DescriptiveMark}</div>

                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>{label.TotalMarks}</span>
                                                                                    <b>{sub.examSubjectConfig?.[0]?.totalMarks}</b>
                                                                                </div>

                                                                                <div className="d-flex justify-content-between">
                                                                                    <span>{label.QualifyingMarks}</span>
                                                                                    <b>{sub.examSubjectConfig?.[0]?.qualifyingMarks}</b>
                                                                                </div>
                                                                            </div>
                                                                        )}

                                                                    </td>

                                                                    {/* ===== INTERVIEW ===== */}

                                                                    {index === 0 && (
                                                                        <td rowSpan={group.subjects.length}>
                                                                            {group.interviewRequired && group.interviewConfig ? (
                                                                                <ConfigCard title="Interview" data={group.interviewConfig} />
                                                                            ) : (
                                                                                <span className="text-muted">—</span>
                                                                            )}
                                                                        </td>
                                                                    )}


                                                                    {/* ===== PHYSICAL ===== */}
                                                                    {index === 0 && (
                                                                        <td rowSpan={group.subjects.length}>
                                                                            {group.physicalTestRequired && group.physicalTestConfig ? (
                                                                                <div className="border rounded p-2 bg-light small">
                                                                                    <div className="fw-bold text-center mb-1">Physical Test</div>

                                                                                    <div className="d-flex justify-content-between">
                                                                                        <span>{label.TotalMarks}</span>
                                                                                        <b>{group.physicalTestConfig.totalMarks}</b>
                                                                                    </div>

                                                                                    <div className="d-flex justify-content-between">
                                                                                        <span>{label.QualifyingMarks}</span>
                                                                                        <b>{group.physicalTestConfig.qualifyingMarks}</b>
                                                                                    </div>

                                                                                    <hr className="my-1" />

                                                                                    <div className="d-flex justify-content-between">
                                                                                        <span>{label.Height}</span>
                                                                                        <b>{group.physicalTestConfig.height || "-"}</b>
                                                                                    </div>

                                                                                    <div className="d-flex justify-content-between">
                                                                                        <span> {label.Chest}</span>
                                                                                        <b>{group.physicalTestConfig.chest || "-"}</b>
                                                                                    </div>

                                                                                    <div className="d-flex justify-content-between">
                                                                                        <span>{label.Running}</span>
                                                                                        <b>{group.physicalTestConfig.running || "-"}</b>
                                                                                    </div>
                                                                                </div>
                                                                            ) : (
                                                                                <span className="text-muted">—</span>
                                                                            )}
                                                                        </td>
                                                                    )}

                                                                    {/* ===== MEDICAL ===== */}
                                                                    {index === 0 && (
                                                                        <td rowSpan={group.subjects.length}>
                                                                            {group.medicalTestRequired && group.medicalTestConfig ? (
                                                                                <div className="text-center">
                                                                                    <span className={`badge ${group.medicalTestConfig.medicalTestQualifyingStatus === "PASS"
                                                                                        ? "bg-success"
                                                                                        : "bg-danger"
                                                                                        }`}>
                                                                                        {group.medicalTestConfig.medicalTestQualifyingStatus}
                                                                                    </span>
                                                                                </div>
                                                                            ) : (
                                                                                <span className="text-muted">—</span>
                                                                            )}
                                                                        </td>
                                                                    )}

                                                                    {/* ===== SKILL ===== */}
                                                                    {index === 0 && (
                                                                        <td rowSpan={group.subjects.length}>
                                                                            {group.skillTestRequired && group.skillTestConfig ? (
                                                                                <ConfigCard title="Skill Test" data={group.skillTestConfig} />
                                                                            ) : (
                                                                                <span className="text-muted">—</span>
                                                                            )}
                                                                        </td>
                                                                    )}
                                                                </tr>
                                                            ))}
                                                        </>
                                                    ) : (
                                                        /* ===== POST LEVEL ONLY ===== */
                                                        <tr>
                                                            <td className="fw-bold ">
                                                                <span className="text-primary">
                                                                    {group.postCriteriaConfigs
                                                                        ?.map(p => getPostNameById(p.postId))
                                                                        .join(", ")}
                                                                </span>

                                                                {group.postMarks && (
                                                                    <div
                                                                        className="border rounded p-2 mt-2 bg-light small fixed-des-mark"
                                                                    >
                                                                        <div className="fw-bold mb-2">{label.postMarks}</div>

                                                                        <div className="d-flex justify-content-between">
                                                                            <span>{label.TotalMarks}</span>
                                                                            <b>{group.postMarks.totalMarks}</b>
                                                                        </div>

                                                                        <div className="d-flex justify-content-between">
                                                                            <span>{label.QualifyingMarks}</span>
                                                                            <b>{group.postMarks.qualifyingMarks}</b>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                {group.interviewRequired && group.interviewConfig ? (
                                                                    <div className="border rounded p-2 bg-light small">
                                                                        <div className="fw-bold text-center mb-1">{label.Interview}</div>
                                                                        <div className="d-flex justify-content-between">
                                                                            <span>{label.TotalMarks}</span>
                                                                            <b>{group.interviewConfig.totalMarks}</b>
                                                                        </div>
                                                                        <div className="d-flex justify-content-between">
                                                                            <span>{label.QualifyingMarks}</span>
                                                                            <b>{group.interviewConfig.qualifyingMarks}</b>
                                                                        </div>
                                                                    </div>
                                                                ) : <span className="text-muted">—</span>}
                                                            </td>
                                                            <td>
                                                                {group.physicalTestRequired && group.physicalTestConfig ? (
                                                                    <div className="border rounded p-2 bg-light small">
                                                                        <div className="fw-bold text-center mb-1">{label.PhysicalTest}</div>

                                                                        <div className="d-flex justify-content-between">
                                                                            <span>{label.TotalMarks}</span>
                                                                            <b>{group.physicalTestConfig.totalMarks}</b>
                                                                        </div>

                                                                        <div className="d-flex justify-content-between">
                                                                            <span>{label.QualifyingMarks}</span>
                                                                            <b>{group.physicalTestConfig.qualifyingMarks}</b>
                                                                        </div>

                                                                        <hr className="my-1" />

                                                                        <div className="d-flex justify-content-between">
                                                                            <span>{label.Height}</span>
                                                                            <b>{group.physicalTestConfig.height || "-"}</b>
                                                                        </div>

                                                                        <div className="d-flex justify-content-between">
                                                                            <span>{label.Chest}</span>
                                                                            <b>{group.physicalTestConfig.chest || "-"}</b>
                                                                        </div>

                                                                        <div className="d-flex justify-content-between">
                                                                            <span>{label.Running}</span>
                                                                            <b>{group.physicalTestConfig.running || "-"}</b>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <span className="text-muted">—</span>
                                                                )}
                                                            </td>

                                                            <td>
                                                                {group.medicalTestRequired && group.medicalTestConfig ? (
                                                                    <span className="badge bg-success">
                                                                        {group.medicalTestConfig.medicalTestQualifyingStatus}
                                                                    </span>
                                                                ) : <span className="text-muted">—</span>}
                                                            </td>

                                                            <td>
                                                                {group.skillTestRequired && group.skillTestConfig ? (
                                                                    <div className="border rounded p-2 bg-light small">
                                                                        <div className="fw-bold text-center mb-1">{label.SkillTest}</div>
                                                                        <div className="d-flex justify-content-between">
                                                                            <span>{label.TotalMarks}</span>
                                                                            <b>{group.skillTestConfig.totalMarks}</b>
                                                                        </div>
                                                                        <div className="d-flex justify-content-between">
                                                                            <span>{label.QualifyingMarks}</span>
                                                                            <b>{group.skillTestConfig.qualifyingMarks}</b>
                                                                        </div>
                                                                    </div>
                                                                ) : <span className="text-muted">—</span>}
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ResultFLow; 